import { createSlice } from '@reduxjs/toolkit';
import { IReason } from '../../../models/reasons';

interface IReasonState {
    reasons: IReason[],
    isLoading: boolean,
};

const initialState: IReasonState = {
    reasons: [],
    isLoading: false,
};

export const reasonsSlice = createSlice({
    name: 'reasons',
    initialState,
    reducers: {
        setReasons: (state, action) => {
            state.isLoading = false;
            state.reasons = action.payload.reasons;
        },
        startLoadingReasons: (state) => {
            state.isLoading = true;
        }
    }
});

// Action creators are generated for each case reducer function
export const {
    setReasons,
    startLoadingReasons
} = reasonsSlice.actions;